import axiosInstance from '../../redux/axiosInstance';

class ProfessionalVerificationQuestionService {
  listQuestions(page = 1, perPage = 20) {
    return axiosInstance.get('/professional-verification-questions/list', { params: { page, perPage } });
  }

  getById(id) {
    return axiosInstance.get(`/professional-verification-questions/view/${id}`);
  }

  createQuestion(data) {
    return axiosInstance.post('/professional-verification-questions/admins/create', data);
  }

  updateQuestion(id, data) {
    return axiosInstance.patch(`/professional-verification-questions/admins/update/${id}`, data);
  }

  deleteQuestion(id) {
    return axiosInstance.delete(`/professional-verification-questions/admins/delete/${id}`);
  }
}

export default new ProfessionalVerificationQuestionService();
